import { APP_ENV, ENVIRONMENT, Environment } from 'env/environment'
import { Link } from 'react-router'

import { Box, IconButton, Stack, Toolbar, Typography } from '@mui/material'
import { PLATFORM } from '@/constants/platform'
import { useAuthStore } from '@/stores/useAuthStore'
import { setDesktopNavExpanded, useUiStore } from '@/stores/useUiStore'
import { Platform } from '@/types/platform'

import { version } from '../../../package.json'
import { AvatarMenu } from '../AvatarMenu'
import { AppVersion, ConsoleAppBar, EnvironmentBadge, PlatformBadge } from './AppBar.styled'
import { ExpandMenu } from './ExpandMenu'

const getPlatformBadgeText = (platform: Platform) => {
  switch (platform) {
    case PLATFORM.DDE:
      return 'Data'
    case PLATFORM.DGE:
      return 'Streams'
  }
}

const getEnvBadgeText = (env: Environment) => {
  switch (env) {
    case ENVIRONMENT.DEVELOPMENT:
      return 'development'
    case ENVIRONMENT.DDE_SIMULATION:
      return 'sims'
    default:
      return env
  }
}

export const appNameTestId = 'app-name'
export const appVersionTestId = 'app-version'
export const platformBadgeTestId = 'platform-badge'
export const envBadgeTestId = 'env-badge'
export const expandMenuTestId = 'expand-menu'

export const AppBar = () => {
  const isNavExpanded = useUiStore((state) => state.isDesktopNavExpanded)
  const platform = useAuthStore((state) => state.platform)

  return (
    <ConsoleAppBar>
      <Toolbar>
        <IconButton
          onClick={() => setDesktopNavExpanded(!isNavExpanded)}
          color="inherit"
          sx={{ display: 'inline-flex' }}
          data-testid={expandMenuTestId}
        >
          <ExpandMenu open={isNavExpanded} height={28} width={28} />
        </IconButton>

        <Stack direction="row" flexGrow={1} pl={1} alignItems="center" gap={1}>
          <Stack gap={0.5}>
            <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
              <Stack flexDirection="row" gap={0.5}>
                <Typography
                  fontWeight={700}
                  component="span"
                  fontSize="0.6em"
                  data-testid={appNameTestId}
                >
                  Ops Console
                </Typography>
                <AppVersion data-testid={appVersionTestId}>{version}</AppVersion>
              </Stack>
            </Link>
          </Stack>
          <PlatformBadge data-testid={platformBadgeTestId}>
            {getPlatformBadgeText(platform)}
          </PlatformBadge>
          {APP_ENV !== ENVIRONMENT.PRODUCTION && (
            <EnvironmentBadge data-testid={envBadgeTestId}>
              {getEnvBadgeText(APP_ENV)}
            </EnvironmentBadge>
          )}
        </Stack>

        <Box sx={{ flexGrow: 0 }}>
          <AvatarMenu />
        </Box>
      </Toolbar>
    </ConsoleAppBar>
  )
}
